import { render, staticRenderFns } from "./AjustesConsol.vue?vue&type=template&id=2b9f0a0a&scoped=true"
import script from "./AjustesConsol.vue?vue&type=script&lang=js"
export * from "./AjustesConsol.vue?vue&type=script&lang=js"
import style0 from "./AjustesConsol.vue?vue&type=style&index=0&id=2b9f0a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f0a0a",
  null
  
)

export default component.exports